/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Medialibrarytoolcrop3Inputs */

const en_medialibrarytoolcrop3 = /** @type {(inputs: Medialibrarytoolcrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crop`)
};

const de_medialibrarytoolcrop3 = /** @type {(inputs: Medialibrarytoolcrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuschnitt`)
};

/**
* | output |
* | --- |
* | "Crop" |
*
* @param {Medialibrarytoolcrop3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const medialibrarytoolcrop3 = /** @type {((inputs?: Medialibrarytoolcrop3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Medialibrarytoolcrop3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_medialibrarytoolcrop3(inputs)
	return de_medialibrarytoolcrop3(inputs)
});
export { medialibrarytoolcrop3 as "mediaLibraryToolCrop" }